import React, { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { DashboardCard } from '@monorepo/nova-ui';

export const WeeklyProfitCardSkeleton: FC = () => {
  return (
    <DashboardCard
      sx={{
        justifyContent: 'space-between',
      }}
    >
      {/* Title */}
      <Skeleton variant="text" width={90} height={20} sx={{ mb: 2 }} />

      {/* Content */}
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{
          width: '100%',
        }}
      >
        {/* Statistic value */}
        <Skeleton variant="text" width={100} height={32} />

        {/* Tag */}
        <Skeleton variant="rounded" width={60} height={24} />
      </Stack>
    </DashboardCard>
  );
};
